import {NavigationDropdown} from '../components'

const taxonomy = {
	firm: {to: '/search/firm'},
	user: {to: '/search/user'},
	invoice: {to: '/search/invoice'},
}

export const Search = () => <NavigationDropdown name="search" taxonomy={taxonomy} />
